/*
  Holds the page still while a product accordion opens.

  THE PROBLEM
  Tapping DETAILS or SHIPPING & RETURNS made the whole info panel jump and
  bounce before settling. Nothing in this theme scrolls the page on that tap —
  the browser does it by itself. Two things fight over the scroll position at
  once:

    1. Tapping a <summary> focuses it, and the browser scrolls a newly focused
       element into view.
    2. Opening the <details> makes the document taller in the same frame, so
       whatever the browser just scrolled to is immediately wrong, and it
       corrects again.

  On iOS a mid-page scroll can also nudge the toolbar, which changes the
  viewport height and starts the whole argument over. The result is a couple of
  visible bounces.

  THE FIX
  The user tapped a heading that was already on screen, so the correct scroll
  position is simply the one they were already at. Record it on the tap and
  hold it for half a second, overruling anything the browser decides. Any real
  touch or wheel input from the user cancels the hold immediately, so this can
  never fight an actual scroll.

  Deliberately not solved in CSS: overflow-anchor would cover the second cause
  on Chrome, but WebKit has never implemented scroll anchoring, and this store's
  traffic is phones.

  Loaded from snippets/grainy-wall.liquid. To uninstall, delete this file and
  its script tag there.
*/
(function () {
  var HOLD_MS = 500;

  function pin() {
    var target = window.scrollY;
    var deadline = Date.now() + HOLD_MS;
    var cancelled = false;

    function cancel() {
      cancelled = true;
    }

    // Any genuine input from the person wins over the hold.
    window.addEventListener('touchstart', cancel, { passive: true });
    window.addEventListener('wheel', cancel, { passive: true });
    window.addEventListener('keydown', cancel);

    function release() {
      window.removeEventListener('touchstart', cancel);
      window.removeEventListener('wheel', cancel);
      window.removeEventListener('keydown', cancel);
    }

    function hold() {
      if (cancelled || Date.now() > deadline) {
        release();
        return;
      }
      if (Math.abs(window.scrollY - target) > 1) {
        window.scrollTo(0, target);
      }
      requestAnimationFrame(hold);
    }

    requestAnimationFrame(hold);
  }

  document.addEventListener(
    'click',
    function (event) {
      var node = event.target;
      if (!node || !node.closest) return;

      var summary = node.closest('summary');
      if (!summary) return;

      // Only the panels inside the product sheet. The menu drawer and the cart
      // also use <summary>, and those are supposed to move things.
      if (!summary.closest('.product__info-container')) return;

      pin();
    },
    true
  );
})();
